export default __webpack_public_path__ + "static/media/ike-komcare.8fe0bb7c.svg";